import { render, staticRenderFns } from "./NoticeboardFeed.vue?vue&type=template&id=21b66f1c&"
import script from "./NoticeboardFeed.vue?vue&type=script&lang=js&"
export * from "./NoticeboardFeed.vue?vue&type=script&lang=js&"
import style0 from "./NoticeboardFeed.vue?vue&type=style&index=0&id=21b66f1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports